<template>
  <v-container fluid tag="section">
    <base-material-table
      outlined
      :item="item"
      ref="table"
      :excel="excel"
      single-expand
    >
      <template v-slot:head>
        <v-alert text color="warning" dense>
          <v-row align="center">
            <v-col class="grow">
              上月【0】提成时请点击此处提交一个空白的提成结算单！
            </v-col>
            <v-col class="shrink">
             <v-btn dark color="warning" class="px-2" @click="emptySave">提交结算</v-btn>
            </v-col>
          </v-row>
        </v-alert>
      </template>
      <template v-slot:foot="{ total }">
        <td :colspan="item.headers.length" :style="$isMobile ? '' : 'border-top: #e4e4e4 1px solid'">
          <div class="my-3 mx-4">
            合计回款：<span :class="`${$isMobile ? 'size-20': 'size-27'} blue--text font-family-Impact`">{{total === null ? 0 : total.returned}}</span>&nbsp;
            审核中：<span :class="`${$isMobile ? 'size-20': 'size-27'} orange--text font-family-Impact`">{{total === null ? 0 : total.autiding}}</span>&nbsp;<br v-if="$isMobile">
            审核未通过：<span :class="`${$isMobile ? 'size-20': 'size-27'} red--text font-family-Impact`">{{total === null ? 0 : total.noPass}}</span>&nbsp;<br v-if="$isMobile">
            实际回款：<span :class="`${$isMobile ? 'size-20': 'size-27'} teal--text font-family-Impact`">{{total === null ? 0 : total.geted}}</span>&nbsp;<br v-if="$isMobile">
            实际提成：<span :class="`${$isMobile ? 'size-20': 'size-27'} green--text font-family-Impact`">{{total === null ? 0 : total.ratioPrice}}</span>&nbsp;
          </div>
        </td>
      </template>
      <template v-slot:condition>
        <v-col cols="12" md='2' class="pl-0">
          <base-marerial-user-select  @on-change="loadData" outlined dense hide-details='auto' v-model="item.params.uids" :menu='$constants.SysMenu.RETURN_M_ID'></base-marerial-user-select>
        </v-col>
      </template>
      <template v-slot:expanded-content="{ headers, item, refresh }">
        <td :colspan="headers.length" v-if='refresh' class="px-0">
          <v-divider v-if="$isMobile"></v-divider>
          <v-tabs v-model="tab">
            <v-tab>回款详情</v-tab>
            <v-tab>合同详情</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <detail-view mini :item='item | formatObjectToArray'></detail-view>
            </v-tab-item>
            <v-tab-item>
              <contract-view mini :item='item.contract' lazy></contract-view>
            </v-tab-item>
          </v-tabs-items>
        </td>
      </template>
    </base-material-table>
  </v-container>
</template>

<script>
  import { fmAuditColor } from '@/utils/stringUtil.js'
  import { getByPids } from '@/api/system/dictionary.js'
  import { serviceApply, serviceEmptyApply } from '@/api/contract/settle.js'
  import ContractView from '@/views/pages/pc/contract/info/components/Detail.vue'
  import DetailView from './components/Detail.vue'

  export default {
    name: 'FinanceReturned',
    components: {
      DetailView,
      ContractView
    },
    data() {
      return {
        tab: '',
        item: {
          mobile: true,
          path: 'returned/money/list',
          total: true,
          bankAccountItems: [],
          topButtons: [
            { event: 'search', show: true },
            { event: 'download', show: this.$_has('con-return-money-down') },
          ],
          params: {
            uids: []
          },
          sort: {
            orderByField: 'return_time',
            asc: false
          },
          headers: [
            {
              text: '详情',
              align: 'center',
              divider: true,
              width: 60,
              class: 'fixed-left',
              cellClass: 'fixed-left',
              value: '',
              sortable: false,
              mobile: true,
              icon: {
                value: 'mdi-dots-horizontal',
                onClick: (row, idx) => {
                  this.$refs.table.showMore(row, idx)
                }
              }
            },
            {
              text: '客户名称',
              align: 'center',
              divider: true,
              width: 200,
              copy: true,
              value: 'customer.name',
              sortable: false,
              mobile: true,
              search: { type: 'input', mobile: true }
            },
            {
              text: '产品名称',
              align: 'center',
              divider: true,
              width: 210,
              copy: true,
              value: 'product.name',
              sortable: false,
              search: { type: 'input' }
            },
            {
              text: '合同编号',
              align: 'center',
              divider: true,
              width: 210,
              copy: true,
              value: 'contract.serialNumber',
              sortable: false,
              search: { type: 'input' }
            },
            {
              text: '合同状态',
              align: 'center',
              divider: true,
              width: 110,
              value: 'contract.stateDic.name',
              sortable: false,
            },
            {
              text: '收款金额',
              align: 'center',
              divider: true,
              value: 'money',
              mobile: true,
              width: 120,
              sortable: false
            },
            {
              text: '本次提成',
              align: 'center',
              divider: true,
              value: 'ratioPrice',
              width: 120,
              mobile: true,
              sortable: false
            },
            {
              text: '审核状态',
              align: 'center',
              divider: true,
              width: 120,
              value: 'order',
              sortable: false,
              mobile: true,
              chip: {
                color: (val) => fmAuditColor(val.auditStatus),
                formatter: (val) => val.auditStatusVal
              },
              search: {
                mobile: true,
                type: 'select',
                secKey: 'auditStatus',
                multiple: true,
                model: [0, 1],
                options: () => [
                  { label: '审核中', value: 0 },
                  { label: '已通过', value: 1 },
                  { label: '未通过', value: -1 }
                ]
              }
            },
            {
              text: '回款日期',
              align: 'center',
              divider: true,
              width: 120,
              value: 'returnTime',
              sortable: true,
              mobile: true,
              search: {
                type: 'date',
                secKey: 'returnTime',
                range: true,
                multiple: true
              },
              formatter: (val) => this.$moment(val * 1000).format('YYYY-MM-DD')
            },
            {
              text: '发放申请',
              align: 'center',
              divider: true,
              width: 110,
              value: 'applyPay',
              sortable: false,
              mobile: true,
              formatter: (val) => (val === 0 ? '未申请' : val === 1 ? '已申请' : '已发放'),
              search: {
                type: 'select',
                options: () => [
                  { label: '未申请', value: 0 },
                  { label: '已申请', value: 1 },
                  { label: '已发放', value: 2 }
                ]
              }
            },
            {
              text: '回款类型',
              align: 'center',
              divider: true,
              width: 120,
              mobile: true,
              value: 'returnTypeDic.name',
              sortable: false
            },
            {
              text: '回款状态',
              align: 'center',
              divider: true,
              width: 120,
              mobile: true,
              value: 'returnStateDic.name',
              sortable: false
            },
            {
              text: '创建人',
              align: 'center',
              divider: true,
              value: 'createUser.name',
              width: 120,
              mobile: true,
              sortable: false
            },
            {
              text: '创建时间',
              align: 'center',
              value: 'createTime',
              width: 120,
              sortable: false,
              divider: true,
              mobile: true,
              search: {
                type: 'date',
                secKey: 'createTime',
                range: true,
                multiple: true
              },
              formatter: (val) => this.$moment(val * 1000).format('YYYY-MM-DD')
            },
            {
              text: '通过日期',
              align: 'center',
              divider: true,
              width: 120,
              value: 'order.updateTime',
              sortable: true,
              mobile: true,
              search: {
                type: 'date',
                secKey: 'updateTime',
                range: true,
                multiple: true
              },
              formatter: (val) => this.$moment(val * 1000).format('YYYY-MM-DD')
            },
            {
              text: '回款账户',
              align: 'center',
              divider: true,
              width: 180,
              mobile: true,
              value: 'returnAccountDic.name',
              sortable: false,
              search: {
                type: 'select',
                itemText: 'name',
                itemValue: 'id',
                secKey: 'returnAccountId',
                options: () => this.bankAccountItems
              }
            },
            {
              text: '操作',
              value: 'actions',
              align: 'center',
              sortable: false,
              width: 100,
              class: 'fixed-right',
              cellClass: 'fixed-right',
              mobile: true,
              menu: {
                text: '操作',
                color: 'primary',
                icon: 'mdi-menu-down-outline',
                actions: [
                  {
                    text: '申请发放',
                    color: 'primary',
                    icon: 'mdi-charity',
                    onClick: (row) => {
                      this.save({
                        returnedId: row.id,
                        collectId: row.collectId,
                        contractId: row.contractId,
                        status: 1 // 20260207默认主管通过
                      })
                    },
                    disable: (row) => this.checkApplyFive(row) || row.contract.signUser.indexOf(`:${this.$store.state.userInfo.id},`) === -1 || row.applyPay > 0 || !this.$_has('service-settle-apply') || row.order.auditStatus !== 1 || (this.$constants.ProductType.TypeTwoThree.indexOf(row.product.stateId) !== -1 && row.contract.stateId !== this.$constants.ContractState.PASS_ID) || (row.contract.stateId === this.$constants.ContractState.STOP_ID && !this.$_has('service-constract-stop-apply')) // || (Number(this.$moment().format("DD")) > 10) || Number(this.$moment(row.returnTime * 1000).format('YYYYMM')) >= Number(this.$moment().format('YYYYMM'))
                  }
                ]
              }
            }
          ]
        },
        excel: {
          path: 'returned/money/down',
          filename: `回款信息.xls`,
          fields: {
            客户名称: 'customer.name',
            合同状态: 'contract.stateDic.name',
            合同单号: 'contract.serialNumber',
            签订项目: 'product.name',
            收款金额: 'money',
            收款账户: 'returnAccountDic.name',
            本次提成: 'ratioPrice',
            提成申请: {
              field: 'applyType',
              callback: (val) => (val === 0 ? '未申请' : val === 1 ? '已申请' : '已发放'),
            },
            回款类型: 'returnTypeDic.name',
            创建人: 'createUser.name',
            回款时间:  {
              field: 'returnTime',
              callback: (value) => this.$moment(value * 1000).format('YYYY-MM-DD')
            },
            通过时间:  {
              field: 'order.updateTime',
              callback: (value) => this.$moment(value * 1000).format('YYYY-MM-DD')
            },
            创建时间: {
              field: 'createTime',
              callback: (value) => this.$moment(value * 1000).format('YYYY-MM-DD')
            }
          }
        }
      }
    },
    methods: {
      loadData () {
        this.$refs.table.loadData()
      },
      checkApplyFive (row) {
        // 五类项目
        if (this.$constants.ProductType.TypeFive.indexOf(row.product.stateId) !== -1) {
          // 项目通过直接提成所有 / 签订时间 小于 2025-08-16 之前的可提所有
          if (row.contract.stateId === this.$constants.ContractState.PASS_ID || row.contract.signTime < 1755273600) {
            return false
          }
          // 项目未通过
          // let haveApply = false
          // for (let i = 0; i < row.returnedMoneyList.length; i++) {
          //   // 已经有提交过的申请
          //   if (row.returnedMoneyList[i].applyPay > 0) {
          //     haveApply = true
          //     break;
          //   }
          //   haveApply = row.splitNumber > 1
          // }
          return row.splitNumber > 1
        }
        return false
      },
      save (form) {
        console.log(form)
        this.$dialog.confirm({
          text: `确认提交发放申请吗?`,
          title: '系统提示',
          width: 300,
          actions: {
            false: { color: 'grey', text: '取消' },
            true: {
              color: 'primary',
              text: '确认',
              handle: () => new Promise(resolve => {
                serviceApply(form).then(response => {
                  const { status } = response
                  if (status === 200) {
                    this.loadData()
                    this.$dialog.notify.success(`提交成功`, { position: 'top-right', timeout: 4000 })
                  }
                  resolve(response)
                })
              })
            }
          }
        })
      },
      async getSelectItems () {
        await getByPids(
            {
            pids: [
              this.$constants.bankAccountPid,
            ]
          }
        ).then(res => {
          if (res.status === 200) {
            const this_ = this
            res.data.forEach((result) => {
              if (this_.$constants.bankAccountPid === result.id) {
                this_.bankAccountItems = result.data
              }
            })
          }
        })
      },
      emptySave () {
        this.$dialog.confirm({
          text: `确认提交空白申请单吗?`,
          title: '系统提示',
          width: 300,
          actions: {
            false: { color: 'grey', text: '取消' },
            true: {
              color: 'primary',
              text: '确认',
              handle: () => new Promise(resolve => {
                serviceEmptyApply().then(response => {
                  const { status } = response
                  if (status === 200) {
                    this.loadData()
                    this.$dialog.notify.success(`提交成功`, { position: 'top-right', timeout: 4000 })
                  }
                  resolve(response)
                })
              })
            }
          }
        })
      }
    },
    created () {
      this.getSelectItems()
    }
  }
</script>

<style>
</style>
